import React from "react";

const WhatsappIcon = () => {
  return (
    <>
      <div className="whatsapp_float">
        <a href="https://wa.me/917987105491" target="_blank">
          <img
            src="https://yogeshsolarenergy.com/WhatsappLogo_1.gif"
            // src="assets/school/WhatsappLogo.png"
            width="50px"
            className="whatsapp_float_btn"
          />
        </a>
      </div>
    </>
  );
};

export default WhatsappIcon;
